import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LayoutPage } from "./layout.page";

const routes: Routes = [
  {
    path: "web",
    component: LayoutPage,
    children: [
      {
        path: "home",
        loadChildren: () =>
          import("../pages/home/home.module").then((m) => m.HomePageModule),
      },
      {
        path: "how-it-works",
        loadChildren: () =>
          import("../pages/how-it-works/how-it-works.module").then(
            (m) => m.HowItWorksPageModule
          ),
      },
      {
        path: "service",
        loadChildren: () =>
          import("../pages/service/service.module").then(
            (m) => m.ServicePageModule
          ),
      },
      {
        path: "products",
        loadChildren: () =>
          import("../pages/products/products.module").then(
            (m) => m.ProductsPageModule
          ),
      },
      {
        path: "contact-us",
        loadChildren: () =>
          import("../pages/contact-us/contact-us.module").then(
            (m) => m.ContactUsPageModule
          ),
      },
      {
        path: "about-us",
        loadChildren: () =>
          import("../pages/about-us/about-us.module").then(
            (m) => m.AboutUsPageModule
          ),
      },
      {
        path: "generic",
        loadChildren: () =>
          import("../pages/generic-page/generic.module").then(
            (m) => m.GenericPageModule
          ),
      },
      {
        path: "",
        redirectTo: "/web/home",
        pathMatch: "full",
      },
    ],
  },
  {
    path: "",
    redirectTo: "/web/home",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutPageRoutingModule {}
